// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"c5aead33","703":"422af31a","787":"65ebe71f"}[chunkId] + ".chunk.js";
};